import React, { Component } from "react";
import { Site, Dimmer } from "tabler-react";
import axios from "axios";
import { getAPISMaster } from '../functions/getLambdasEndpoints';


/**
 * Clase para el codigo de la funcion deslogueo
 * @author Joel Martinez <joel.martinez@mxmart.mx>
 * @version 1.0 09/07/2021
 */
class Logout extends Component {
	
	componentDidMount = async () => {
		let urlLoguout = "https://onelogin-saml-ieu.auth.us-east-1.amazoncognito.com/logout?&client_id=3bl6u63nn4268k66hbtkh111p4&logout_uri=" + window.location.origin;
		const apiAuthLogout = await axios.delete(getAPISMaster().apis.apiAuth.endpoint, {access_token: localStorage.getItem('access_token')});
		if (apiAuthLogout.status) {
			localStorage.clear();
			window.location.href = urlLoguout;
		}
	}

	render() {
		return (
			<Site>
				<Dimmer loader active />
			</Site>
		)
	}
}


export default Logout;